import { combineReducers } from 'redux';
import {
    RECEIVE_ACCOUNT_PURCHASES,
    REQUEST_ACCOUNT_PURCHASES,
    FAILURE_ACCOUNT_PURCHASES
} from './constants';

/*
 * State shape
{
    purchases : [],
    fetching: false,
    error: ''
}
*/

const purchases = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_PURCHASES:
            return action.response.payload;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ACCOUNT_PURCHASES:
            return true;
        case FAILURE_ACCOUNT_PURCHASES:
        case RECEIVE_ACCOUNT_PURCHASES:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ACCOUNT_PURCHASES:
            return action.response.message;
        case REQUEST_ACCOUNT_PURCHASES:
        case RECEIVE_ACCOUNT_PURCHASES:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    purchases,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/cashback/reducer.js